export default __webpack_public_path__ + "static/media/kick-icon.b208fcec.svg";